(() => {
  const visibleMs = 12 * 60 * 60 * 1000;
  const hiddenMs = 24 * 60 * 60 * 1000;
  const resolveCycle = (raw, now, eligible) => {
    let cycle = null;
    if (raw !== null) {
      try { cycle = JSON.parse(raw); } catch { cycle = null; }
      if (cycle && (cycle.version !== 1 || !Number.isFinite(cycle.startedAt) || cycle.startedAt <= 0 || cycle.startedAt > now || cycle.expiresAt !== cycle.startedAt + visibleMs || cycle.hiddenUntil !== cycle.expiresAt + hiddenMs)) cycle = null;
    }
    if ((!cycle || now >= cycle.hiddenUntil) && eligible) {
      cycle = { version: 1, startedAt: now, expiresAt: now + visibleMs, hiddenUntil: now + visibleMs + hiddenMs };
    }
    if (!cycle) return { state: 'ineligible' };
    return { cycle, state: !eligible ? 'ineligible' : now < cycle.expiresAt ? 'visible' : 'hidden', remaining: Math.max(0, Math.ceil((cycle.expiresAt - now) / 1000)) };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { resolveCycle, visibleMs, hiddenMs };
  if (typeof document === 'undefined') return;
  const boot = scope => scope.querySelectorAll('[data-mfl-offer]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const panel = root.querySelector('[data-offer-panel]');
    const percent = root.querySelector('[data-offer-percent]');
    const countdown = root.dataset.countdown === 'true';
    let variants;
    try { variants = JSON.parse(root.dataset.variants); } catch { return; }
    const byId = new Map(variants.map(variant => [String(variant.id), variant]));
    let selectedId = root.dataset.initialVariant;
    const key = root.dataset.offerKey;
    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    const formVariant = () => {
      const main = document.querySelector('[id$="__main-product"]');
      const fields = main?.querySelectorAll('form[action*="/cart/add"] [name="id"]') || [];
      for (const field of fields) if (byId.has(String(field.value))) return String(field.value);
      return null;
    };
    const section = root.closest('.shopify-section');
    const setVisible = visible => {
      root.hidden = !visible;
      panel.hidden = !visible;
      if (section) section.hidden = !visible;
    };
    const hide = () => setVisible(false);
    const render = () => {
      if (!root.isConnected) { clearInterval(timer); controller.abort(); return; }
      if (document.hidden) return;
      selectedId = formVariant() || selectedId;
      const variant = byId.get(String(selectedId));
      const comparison = Number(variant?.compare_at_price);
      const price = Number(variant?.price);
      const eligible = Boolean(variant?.available && comparison > price && comparison > 0);
      if (!countdown) {
        root.dataset.offerState = 'disabled';
        hide();
        return;
      } else {
        let state;
        try {
          const raw = localStorage.getItem(key);
          state = resolveCycle(raw, Date.now(), eligible);
          if (state.cycle) {
            const saved = JSON.stringify(state.cycle);
            if (raw !== saved) localStorage.setItem(key, saved);
          }
        } catch { root.dataset.offerState = 'storage-unavailable'; hide(); return; }
        root.dataset.offerState = state.state;
        if (state.cycle) root.dataset.offerNextVisible = String(state.cycle.hiddenUntil);
        if (state.state !== 'visible') { hide(); return; }
        setVisible(true);
        const remaining = state.remaining;
        const pad = value => String(value).padStart(2, '0');
        root.querySelector('[data-offer-hours]').textContent = pad(Math.floor(remaining / 3600));
        root.querySelector('[data-offer-minutes]').textContent = pad(Math.floor(remaining % 3600 / 60));
        root.querySelector('[data-offer-seconds]').textContent = pad(remaining % 60);
      }
      if (eligible) percent.textContent = `${(Math.floor((comparison - price) * 1000 / comparison) / 10).toLocaleString(document.documentElement.lang || 'bg', { maximumFractionDigits: 1 })}%`;
    };
    const onVariant = event => {
      const id = event.detail?.variant?.id || event.detail?.id || (event.target?.name === 'id' && event.target.value);
      if (id && byId.has(String(id))) selectedId = String(id);
      requestAnimationFrame(render);
    };
    document.addEventListener('change', onVariant, { ...listenerOptions, capture: true });
    ['variant:change', 'product:variant-change', 'pf:variant-change'].forEach(name => document.addEventListener(name, onVariant, listenerOptions));
    document.addEventListener('visibilitychange', render, listenerOptions);
    window.addEventListener('storage', event => { if (event.key === key || event.key === null) render(); }, listenerOptions);
    root.querySelector('.mfl__offer-cta')?.addEventListener('click', event => {
      const personalize = document.querySelector('[data-mfos-personalize]');
      if (personalize && !personalize.disabled) {
        event.preventDefault();
        event.stopPropagation();
        personalize.click();
        return;
      }
      const target = document.getElementById('mfos-wizard');
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - 120, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, listenerOptions);
    let timer;
    render();
    timer = setInterval(render, 1000);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
